import { PaymentStatus } from 'constants/payment';
import { useAppSelector } from 'store/hooks';
import { Fade } from 'views/shared/fade';

import { CheckError } from '../check-error';
import { PaymentContainer } from '../payment-container';
import { PreloaderView } from '../preloader-view';

const BaseCardWrapper = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const { isOverlayLoader } = useAppSelector((state) => state.app);

  if (isOverlayLoader) {
    return (
      <Fade className="w-full h-full flex flex-grow flex-col md:max-h-[534px]">
        <PreloaderView />
      </Fade>
    );
  }

  const renderBaseCard = () => {
    switch (paymentData?.status) {
      case PaymentStatus.WAIT_PAYMENT:
      case PaymentStatus.PAYMENT_SUCCESS:
      case PaymentStatus.WAIT_PROCESSING:
      case PaymentStatus.HOLDED:
      case PaymentStatus.PAYMENT_FAILED:
      case PaymentStatus.INTERNAL_ERROR:
        return <PaymentContainer />;
      case PaymentStatus.INVOICE_DISABLED:
      case PaymentStatus.RETRYABLE_FAILED:
      case PaymentStatus.PAYMENT_TIMEOUT:
      case PaymentStatus.INCORRECT_DATA:
      case PaymentStatus.PAYMENT_NOTFOUND:
      case PaymentStatus.ANTIFROD_DECLINED:
        return <CheckError />;
      default:
        return <PreloaderView />;
    }
  };

  return (
    <Fade className="w-full h-full flex flex-grow flex-col md:max-h-[534px]">
      {renderBaseCard()}
    </Fade>
  );
};

export { BaseCardWrapper };
